var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutSvg3 = function SvgAboutSvg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 98,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "about-svg-3_svg__a",
    width: 42,
    height: 72,
    x: 0,
    y: 26,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 73.962 41.444 23.93.136-47.848L.136 26.114z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#about-svg-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205287",
    d: "M22.547 39.009c-.701-.405-1.346-.765-1.91-1.079-.565-.314-1.053-.583-1.442-.81q-.392-.226-.642-.391c-.242-.157-.97-.584-2.013-1.186-1.69-.975-4.201-2.408-6.79-3.886-2.584-1.476-5.248-2.997-7.254-4.153-.967-.557-1.78-1.031-2.357-1.375L.1 38.985s7.014 4.129 12.155 7.096l-.002-3.476q.612.369 1.324.778c.788.455 1.656.946 2.567 1.462.914.517 1.873 1.06 2.837 1.617 2.662 1.537 5.387 3.192 7.427 4.76.333.264 1.09.88 1.828 1.942 1.166 1.61 1.577 3.45 1.323 4.667-.042.25-.122.749-.423 1.109-.155.183-1.076 1.201-3.434.559-.86-.234-1.662-.623-2.43-.994l-10.066-5.81c-.357-.207-.698-.402-1.012-.585l-.027 9.81c1.561.904 4.462 2.574 7.195 4.15 2.318 1.338 4.515 2.611 5.674 3.29.525.307.922.56 1.31.85.137.102.334.256.563.453 2.456 2.011 5.035 6.889 2.445 8.327-1.982.866-4.488-.149-8.012-2.17a1236 1236 0 0 1-5.576-3.205c-2.04-1.178-3.804-2.2-3.788-2.19l.019-6.185L.045 58.338 0 73.902l2.717 1.57c1.46.844 3.205 1.848 4.411 2.54l2.595 1.492a731 731 0 0 1 4.214 2.448c.994.581 1.657.973 2.214 1.295.311.181.591.338.879.498 2.128 1.114 4.3 2.352 6.316 3.516q.552.32 1.09.629l1.06.613c2.362 1.364 4.36 2.493 5.596 2.988 5.831 2.507 10.54-.913 10.394-7.733.072-4.683-.357-8.521-4.57-13.558 1.587-.706 3.31-.41 4.427-4.553.82-3.58-1.434-10.397-4.947-15.202-3.852-5.272-9.803-9.1-13.85-11.436"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "about-svg-3_svg__b",
    width: 83,
    height: 48,
    x: 1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.076 24.163 41.204 23.79 40.938-23.79L42.014.373z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#about-svg-3_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205287",
    d: "M83.218 24.16 42.014.37 31.968 6.21l13.357 19.768-34.137-7.693L1.076 24.16 42.28 47.95l9.816-5.703L34.102 31.86l19.547 4.38 9.42-5.474-7.58-11.245 17.915 10.344z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "about-svg-3_svg__c",
    width: 41,
    height: 69,
    x: 43,
    y: 26,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m43.54 49.666.127 45.218L84 71.597l-.128-45.215z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#about-svg-3_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205287",
    d: "m71.854 33.316-16.215 9.36q-12.1 6.987-12.088 11.196l.04 14.159c.008 2.826 4.057 6.366 12.125 1.71l16.135-9.316.027 9.159-16.135 9.315-.01-3.724-12.102 6.987.024 8.479q.013 4.239 12.112-2.746l16.135-9.316q11.775-6.8 12.088-11.225l-.053-18.37q-.092-4.191-12.033 2.701L55.69 61.046l-.027-9.377 16.135-9.264.01 3.673 12.1-6.987-.024-8.48q-.01-4.235-12.03 2.705"
  }))));
};
export default SvgAboutSvg3;